import { createContext } from "react";
import { type DayOption, } from "../utils/types";
import { PickupLocation } from "../../../api/pickupLocations";

// This is what we use to create, remove or edit the pickup locations.

export interface PickupLocationContextType {
  pickupLocations: PickupLocation[];
  loading: boolean;
  error: string | null;
  fetchPickupLocations: () => Promise<void>;
  createPickupLocation: (
    name: string,
    address: string,
    latitude: number,
    longitude: number,
    days: DayOption[],
  ) => Promise<void>;
  updatePickupLocation: (
    id: string,
    name?: string,
    address?: string,
    latitude?: number,
    longitude?: number,
    days?: DayOption[],
  ) => Promise<void>;
  deletePickupLocation: (id: string) => Promise<void>;
  refreshPickupLocations: () => Promise<void>;
}

export const PickupLocationContext = createContext<PickupLocationContextType>({
  pickupLocations: [],
  loading: false,
  error: null,
  fetchPickupLocations: () => Promise.resolve(),
  createPickupLocation: () => Promise.resolve(),
  updatePickupLocation: () => Promise.resolve(),
  deletePickupLocation: () => Promise.resolve(),
  refreshPickupLocations: () => Promise.resolve(),
});
